/**
 * @brief 视图语言包
 * @date 2025年07月08日17:27:02
 */
export default {
  视图预览: 'View Preview',
  '注：预览区的数据为样例数据。': 'Note: The data in the preview area is sample data.',
  视图配置: 'View Configuration',
  新建视图: 'New View',
  外部视图: 'External View',
  看板: 'Dashboard',
  外部页面: 'External Page',
  自定义范围: 'Custom Range',
  应用场景: 'Application Scenario',
  PC端: 'PC',
  移动端: 'Mobile',
  显示方式: 'Display Mode',
  显示全部字段: 'Display All Fields',
  与PC端保持一致: 'Keep Consistent with PC',
  最多显示个数: 'Maximum Number of Displayed Items',
  请输入最多显示个数: 'Please enter the maximum number of displayed items',
  '请输入完整的页面链接，以http或https开头，否则将无法保存': 'Please enter the complete page link, starting with http or https, otherwise it will not be saved',
  '请输入完整的页面链接，以https开头，否则将无法保存': 'Please enter the complete page link, starting with https, otherwise it will not be saved',
  '请输入完整的页面链接，以http或https开头': 'Please enter the complete page link, starting with http or https',
  '请输入完整的页面链接，以https开头': 'Please enter the complete page link, starting with https',
  开启自定义显示列提示: 'Enable Custom Display Columns Prompt',
  '调整显示列设置后，所选字段排序将不再跟随表单设计也字段排布顺序变化，后续新增字段需要手动调整显示列排序位置，是否确定保存？': 'After adjusting the display column settings, the selected field sorting will no longer follow the form design and field arrangement order, and subsequent new fields need to manually adjust the display column sorting position. Are you sure you want to save?',
  '创建视图中，请稍后': 'Creating a view, please wait',
  请选择排序字段: 'Please select a sorting field',
  分组字段: 'Group Field',
  请设置分组字段: 'Please set the group field',
  选择分组字段: 'Select Group Field',
  请选择分组字段: 'Please select a group field',
  '选择一个字段作为“分组”，数据将按照此字段中的字段值分组显示在看板中。仅支持单选、下拉单选和人员类型字段。': 'Select a field as a "group" and the data will be grouped by the field value in the dashboard. Only single-selection, single-selection drop-down, and person type fields are supported.',
  表格视图: 'Table View',
  看板视图: 'Dashboard View',
  卡片配置: 'Card Configuration',
  显示全部: 'Display All',
  隐藏全部: 'Hide All',
  隐藏字段名: 'Hide Field Name',
  分组方式: 'Grouping Method'
};
